module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Medium.1f67d270.woff2";